"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsibleGamingReducer = responsibleGamingReducer;
var _types = require("./types");
var initialState = {
  on: false,
  result: 0,
  loss: 0,
  win: 0,
  sessionStarted: new Date(),
  lastShowed: new Date(),
  totalRounds: 0
};
function responsibleGamingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.RC_ON:
      {
        return Object.assign({}, state, {
          on: true,
          reminderInterval: action.payload ? action.payload : 3600
        });
      }
    case _types.RC_WIN:
      {
        return Object.assign({}, state, {
          win: state.win + action.payload,
          result: state.result + action.payload
        });
      }
    case _types.RC_LOSS:
      {
        return Object.assign({}, state, {
          loss: state.loss + action.payload,
          result: state.result - action.payload,
          totalRounds: state.totalRounds + state.totalRounds
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map